// extracted by mini-css-extract-plugin
export default {"partners":"styles_partners__3Dx28","partnersInner":"styles_partnersInner__sUFsh","partnerCard":"styles_partnerCard__idHAD"};